import { defineComponent as n, createBlock as r, openBlock as a, unref as p, mergeProps as s, withCtx as l, createElementVNode as m } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const d = /* @__PURE__ */ n({
  name: "IconPlus",
  __name: "IconPlus",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (u, e) => (a(), r(p(c), s(o, { "view-box": "0 0 24 24" }), {
      default: l(() => [...e[0] || (e[0] = [
        m("path", { d: "M12.75 6a.75.75 0 0 0-1.5 0v5.25H6a.75.75 0 0 0 0 1.5h5.25V18a.75.75 0 0 0 1.5 0v-5.25H18a.75.75 0 0 0 0-1.5h-5.25V6" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
